<template>
  <ValidationObserver v-slot="{ handleSubmit, invalid, reset, errors}" ref="observer">
    <artisio-modal size="md" :visible="show" :data="model" scrollable
                   :title="computedTitle" @show="onShow"
                   @hidden="onHidden" @ok.prevent="handleSubmit(onSubmit)" :show-confirmation="showConfirmation"
                   :ok-title="$t('Submit')" :is-loading="loading" modal-class="mobile-full-screen">

      <div class="row">
        <div class="col-md-12">
          <input-widget :model="model" attribute="comment"/>
        </div>
      </div>

    </artisio-modal>
  </ValidationObserver>
</template>

<script>
  import {createNamespacedHelpers} from "vuex";
  import ArtisioModal from "../../core/components/artisio-modal/ArtisioModal";
  import InputWidget from "@/core/components/input-widget/InputWidget";
  import ContractFileModel from "@/modules/contracts/ContractFile.model";
  import ContractService from "@/modules/contracts/ContractService";

  const {mapState, mapActions} = createNamespacedHelpers('contracts');

  export default {
    name: "ContractModal",
    components: {
      InputWidget,
      ArtisioModal
    },
    data() {
      return {
        model: new ContractFileModel(),
        showConfirmation: false,
        loading: false,
        fileModels: [],
        isHiddenFromSubmit: false
      }
    },
    computed: {
      ...mapState({
        editObject: state => state.contractModal.object,
        show: state => state.contractModal.show,
      }),
      computedTitle() {
        if (this.model && this.model.contract_files && this.model.contract_files.length > 0) {
          return this.$i18n.t('Update Contract {name}', {name: this.model.contract_files[0].file})
        }
        return this.$i18n.t('Update Contract')
      }
    },
    watch: {
      async editObject() {
        if (this.editObject && this.editObject.uuid) {
          this.model = new ContractFileModel(this.editObject)
        }
      },
    },
    methods: {
      ...mapActions(['hideContractModal', 'getTableData']),
      onShow() {
        this.showConfirmation = true
      },
      onHidden() {
        this.hideContractModal();
      },
      async onSubmit() {
        let response = await ContractService.partialUpdateContract({
          uuid: this.model.uuid,
          data: {comment: this.model.comment}
        })

        if (response.success) {
          this.$toast('success', this.$i18n.t('Contract has been successfully updated'));
          this.showConfirmation = false
          this.hideContractModal()
          this.getTableData()
        } else {
          this.showConfirmation = true
          if (response.body.non_field_errors) {
            this.$errorDialog(response.body.non_field_errors[0]);
          } else if (response.toastError) {
            this.$errorDialog(response.toastError);
          } else {
            for (let index in response.body.premiums) {
              this.model.premiums[index].setMultipleErrors(response.body.premiums[index]);
            }
          }
        }
      },
    }
  }
</script>

<style lang="scss" scoped>
</style>
